import { WindowHelper } from '../WindowHelper';
import WorkListActiveTouch from './work-list-active-touch';

export default class WorkListActiveState extends WorkListActiveTouch {
    hideAllActive() {
        for (let i = 0; i < this.triggerNodes.length; i++) {
            this.triggerNodes[i].querySelector('.highlighted-work-list-item').classList.remove('is-active');
        }
    }
    attachEvent() {
        for (let i = 0; i < this.triggerNodes.length; i++) {
            this.triggerNodes[i].addEventListener(this.triggerEvent, (event) => {
                this.hideAllActive();
                this.triggerNodes[i].querySelector('.highlighted-work-list-item').classList.add('is-active');
                event.preventDefault();
            }, true);
        }
    }
    init() {
        this.triggerNodes = this.getTriggerNodes();
        this.triggerEvent = WindowHelper.isTouchDevice() ? 'click' : 'mouseover';
        this.attachEvent();
    }
    constructor() {
        super();
        if (WindowHelper.isElementThere('.work-list-container')) this.init();
    }
}
